<template>
  <div
    class="toast-wrapper"
    :class="{ active: this.isActive && this.data.isActive }"
    :style="'z-index: ' + this.zIndex + ';'"
    ref="toast"
  >
    <div
      class="toast"
      :class="[this.data.type]"
      @click="closeToast"
      @mouseover="hoverToast"
      @mouseout="leaveToast"
    >
      <div class="toast-close"><icon icon="times"></icon></div>
      <div class="toast-body" v-html="this.data.text"></div>
      <div class="toast-loader">
        <div class="toast-loader-bar"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Toast',
  components: {},
  props: {
    data: Object,
    index: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      isActive: false,
      hasBeenHovered: false,
      hoverTimeout: false
    }
  },
  methods: {
    closeToast: function() {
      this.$store.commit('closeToast', this.data.id)
    },
    hoverToast: function() {
      this.hasBeenHovered = true
      if (this.hoverTimeout !== false) clearTimeout(this.hoverTimeout)
    },
    leaveToast: function() {
      const $this = this
      if (this.hoverTimeout !== false) clearTimeout($this.hoverTimeout)
      this.hoverTimeout = setTimeout(function() {
        $this.$store.commit('closeToast', $this.data.id)
      }, 6000)
    },
    setTop: function() {
      if (this.$refs['toast']) {
        let newTop = 0
        for (let i = 0; i < this.$store.state.toasts.length; i++) {
          const currToast = this.$store.state.toasts[i]
          if (currToast.id == this.data.id) break
          if (currToast.isActive) {
            if (currToast.height) newTop = newTop + currToast.height
            else newTop = newTop + 60
          }
        }
        this.$refs['toast'].style.top = newTop + 'px'
      }
    }
  },
  computed: {
    zIndex: function() {
      return 1100 + this.index
    }
  },
  created: function() {
    const $this = this

    // Activate
    setTimeout(function() {
      $this.isActive = true
    }, 100)

    // Auto-close
    this.hoverTimeout = setTimeout(function() {
      $this.$store.dispatch('closeToast', $this.data.id).then(() => {
        $this.$root.$emit('toast:update')
      })
    }, 6000)

    // Set top
    this.$root.$on('toast:update', this.setTop)
  },
  mounted: function() {
    if (this.$refs['toast']) {
      const newHeight = this.$refs['toast'].clientHeight
      this.$store
        .dispatch('setToastHeight', {
          toastid: this.data.id,
          height: newHeight
        })
        .then(() => {
          this.$root.$emit('toast:update')
        })

      this.setTop()
    }
  }
}
</script>

<style scoped lang="scss">
.toast {
}
</style>
